/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
angular.module('taric.model.about',['ngResource', 'common.helper']).factory('Metadata', function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/ref/metadata/', {}, {
        get: {
            method: 'GET',
            isArray: false
        }
    });
}).service('AboutModel', function(Metadata, $q){
    var model = this;
    var result;
    model.getMetadata = function(){
        var deferred = $q.defer();
        if (result){
            deferred.resolve(result);
        } else {
            Metadata.get({}, function (returningResult) {
                result = returningResult;
                deferred.resolve(result);
            }, function(error){
                deferred.reject(error);
            });
        }
        return deferred.promise;
    };
});



// WEBPACK FOOTER //
// ./app/about/about-model.js